export default __webpack_public_path__ + "static/media/MANDY.10fc4cdc.png";